import React, { Component } from 'react';
import {withRouter} from "react-router-dom";

import AccountRegistrationForm from "./account-registration-form";
import AccountRegistrationConfirmation from "./account-registration-confirmation";

import { createAccount } from "../../services";
import AnonymousFormLayout from "../../layout/anonymous-form-layout";

class AccountRegister extends Component {
  state = {
    completed: false
  };

  registrationSubmittedCallback = (formData, setSubmitting) => {
    const onSuccess = (response, body) => {
      if (response.status === 201) {
        this.setState({
          ...this.state,
          completed: true
        });
      } else if (response.status === 409) {
        setSubmitting(false);
        this.setState({
          ...this.state,
          error : "Το email αυτό χρησιμοποιείται σε άλλο λογαριασμό."
        });
      }
    };

    const onFail = (errorType, status) => {
      setSubmitting(false);

      this.setState({
        ...this.state,
        error : "Απέτυχε η δημιουργία νέου λογαριασμού"
      });
    };

    createAccount(formData, onSuccess, onFail);
  };

  render() {
    return (
      <AnonymousFormLayout backgroundImageStyle="bg-register-image">
        {
          !this.state.completed &&
          <AccountRegistrationForm error={this.state.error}
                                   registrationSubmittedCallback={this.registrationSubmittedCallback}/>
        }
        {
          this.state.completed &&
          <AccountRegistrationConfirmation email={this.state.email}
                                           secondValidationTokenSent={this.state.secondValidationTokenSent}
                                           onFormSubmit={this.onValidationLinkRequest}/>
        }
      </AnonymousFormLayout>
    );
  }

}

export default withRouter(AccountRegister)